import { render, staticRenderFns } from "./FileGroup.vue?vue&type=template&id=a8b439ac&"
import script from "./FileGroup.vue?vue&type=script&lang=ts&"
export * from "./FileGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports